<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        {{title}}
    </div>
    <div class="nova__dialog__toolbar__controls">
        <button class="nova__button--icon" mat-dialog-close><mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon></button>
    </div>
</div>

<div mat-dialog-content class="nova__dialog__content">
    <div *ngIf="!isLoading && profession">
        <span class="row-item flex-row">
            <span class="row-title flex-width-35">Billing Range Type</span>
            <span class="flex-width-65">
                <mat-radio-group [(ngModel)]="profession.billingRateType" id="billingRangeTypeInput" class="space-between items-stretch">
                    <mat-radio-button class="radio-button" [value]="1">Travel</mat-radio-button>
                    <mat-radio-button class="radio-button" [value]="2">Per Diem</mat-radio-button>
                    <mat-radio-button class="radio-button" [value]="0">Both</mat-radio-button>
                </mat-radio-group>
            </span>
        </span>
        <span class="row-item flex-row">
            <span class="row-title flex-width-35">Local Traveler</span>
            <span class="flex-width-65">
                <mat-radio-group [(ngModel)]="profession.localTraveler" id="localTravelerInput">
                    <mat-radio-button class="radio-button" [value]="true">Yes</mat-radio-button>
                    <mat-radio-button class="radio-button" [value]="false">No</mat-radio-button>
                </mat-radio-group>
            </span>
        </span>
        <span class="row-item flex-row">
            <span class="row-title flex-width-35">Range Billing</span>
            <span class="flex-width-65">
                <mat-radio-group [(ngModel)]="profession.rangeBilling" id="rangeBillingInput">
                    <mat-radio-button class="radio-button" [value]="true">Yes</mat-radio-button>
                    <mat-radio-button class="radio-button" [value]="false">No</mat-radio-button>
                </mat-radio-group>
            </span>
        </span>
        <span class="row-item flex-row">
            <span class="row-title-text flex-width-35">Profession</span>
            <span class="flex-width-65">
                <mat-select [(ngModel)]="profession.professionId" (selectionChange)="professionChanged()" class="profession-select" id="professionInput">
                    <mat-option [value]="p.id" *ngFor="let p of professions$ | async"> {{p.name}}</mat-option>
                </mat-select>
            </span>
        </span>
        <span class="row-item flex-row">
            <span class="row-title-text flex-width-35">Expertises</span>
            <span class="flex-width-65">
                <mat-select multiple #expSel [(ngModel)]="selectedExpertises" class="profession-select" id="expertisesInput">
                    <mat-option [value]="0" *ngIf="(expertises$ | async)?.length" (click)="toggleAllSelection()">All items</mat-option>
                    <mat-option [value]="expertise.id" *ngFor="let expertise of expertises$ | async">{{expertise.name}}</mat-option>
                </mat-select>
            </span>
        </span>
        <mat-error *ngIf="professionAndExpertisesEmptyError()">Please select profession and at least one expertise</mat-error>
    </div>


    <mat-dialog-actions class="nova__dialog__content__actions" align="end">
        <button mat-raised-button color="primary" (click)="save()" [disabled]="professionAndExpertisesEmptyError() || isLoading || isSaving" data-qa-id="an_fc_ep_save_button">{{saveButtonTitle}}</button>
        <button mat-button (click)="close(false)" data-qa-id="an_fc_ep_cancel_button">CANCEL</button>
    </mat-dialog-actions>
</div>
